import { HTTPClient } from "./Client";

const AvaliacaoApi = {
    async CriarAutoAvaliacaoAsync(media, pontosCriteriosID, pontosPositivos, pontosEvolucao, direcionadores) {
        const salvarAutoAvaliacao = {
            media: media,
            pontosCriteriosID: pontosCriteriosID,
            pontosPositivos: pontosPositivos,
            pontosEvolucao: pontosEvolucao,
            direcionadores: direcionadores,
            autoAvaliacao: true
        }

        await HTTPClient.post(`/Avaliacao/SalvarAutoAvaliacao`, salvarAutoAvaliacao);
    },

    async CriarAvaliacaoAsync(alunoId, media, pontosCriteriosID, pontosPositivos, pontosEvolucao, direcionadores, tipoAvaliacaoEnum) {
        const salvarAutoAvaliacao = {
            alunoId: alunoId,
            media: media,
            pontosCriteriosID: pontosCriteriosID,
            pontosPositivos: pontosPositivos,
            pontosEvolucao: pontosEvolucao,
            direcionadores: direcionadores,
            autoAvaliacao: false,
            tipoAvaliacaoEnum: tipoAvaliacaoEnum
        }

        await HTTPClient.post(`/Avaliacao/SalvarAvaliacao`, salvarAutoAvaliacao);
    },

    async ListarAvaliacaoPorAluno(alunoId) {
        const response = await HTTPClient.get(`/Avaliacao/ListarAvaliacoesPorAlunoId/${alunoId}`);
        return response.data;
    },

    async ListarAvaliacoes() {
        const response = await HTTPClient.get(`/Avaliacao/ListarAvaliacoes`);
        return response.data;
    },

    async ObterAvaliacaoCompleta(avaliacaoId) {
        const response = await HTTPClient.get(`/Avaliacao/ObterAvaliacaoCompleta/${avaliacaoId}`);
        return response.data;
    },

    async ListarEnumAvaliacao() {
        const response = await HTTPClient.get(`/Avaliacao/ListarEnumAvaliacao`);
        return response.data;
    },
    async ListarEnumTipoAvaliacao() {
        const response = await HTTPClient.get(`/Avaliacao/TipoAvaliacaoEnum`);
        return response.data;
    },


    async ObterAvalicaoIdMaisRecentePorAluno() {
        const response = await HTTPClient.get(`/Avaliacao/ObterAvalicaoIdMaisRecentePorAlunoId`);
        return response.data;
    },

    async DeletarAvaliacao(avaliacaoId) {

        const response = await HTTPClient.delete(`/Avaliacao/DeletarAvaliacao/${avaliacaoId}`);
        return response.data;
    },

    async AtualizarAvaliacaoAsync(avaliacaoId) {

        const response = await HTTPClient.post(`/Avaliacao/AtualizarAvaliacao`, avaliacaoId);
        return response.data;
    },

}

export default AvaliacaoApi;